import { directPurchaseCredentials } from './direct-purchase/credentials.js';
/** A frame is only a hint. The backend independently verifies the customer's required action. */
export async function verifyRequiredFundingAction(client, provider, operationId) {
    const controller = new AbortController();
    const unsubscribe = client.onDispose(() => controller.abort());
    try {
        // Re-exchanging the one-shot session while a challenge is open can invalidate
        // its authentication. Validate the existing customer credentials instead.
        const credentials = await directPurchaseCredentials(provider, controller.signal);
        if (!credentials)
            return;
        await client.verifyRequiredAction(operationId, credentials.customerId, credentials.accessToken, controller.signal);
    }
    catch {
        if (!controller.signal.aborted)
            client.observeFunnel?.({
                stage: 'customer_verification',
                outcome: 'error',
                errorCode: 'verification_pending',
                operationId,
            });
    }
    finally {
        unsubscribe();
    }
}
